/// <amd-module name="VC/Markdown/Plugins/VCImageTransformer" />

/*
 * This file was ported from the legacy webplatform
 * Logic that is not needed for markdown token transformation was not ported over.
 * Logic has only been changed where necessary to interact in the modern web platform.
 * There is no intention to change any factorings or style otherwise.
 */
import { Uri } from "VSS/Platform/Util/Url";
import { TfvcVersionControlPathUtility } from "VC/Markdown/Plugins/PathUtilities/TfvcVersionControlPathUtility";
import { GitVersionControlPathUtility } from "VC/Markdown/Plugins/PathUtilities/GitVersionControlPathUtility";
import * as VersionControlUrls from "VC/Markdown/Plugins/PathUtilities/VersionControlUrlUtilities";

import * as Git from "VC/Common/Contracts/Git";
import { IVssPageContext } from 'VSS/Platform/Context';

export class VCImageTransformer {

    constructor(
        private repositoryType: VersionControlUrls.RepositoryType,
        private item: Git.ItemModel,
        private repositoryId: string,
        private projectId: string,
        private context: IVssPageContext,
        private itemVersion?: Git.GitVersionDescriptor
    ) { }

    private getGitVersionControlUrl(src: string): string {
        let versionControlPath = GitVersionControlPathUtility.combine(this.item.path, src);
        return VersionControlUrls.getFileContentUrl(this.context, this.repositoryId, this.repositoryType, this.projectId, versionControlPath, true, null, this.itemVersion);
    }

    private getTfsVersionControlUri(src: string): string {
        let versionControlPath = "";
        try {
            versionControlPath = TfvcVersionControlPathUtility.combine(this.item.path, src);
        }
        catch (e) {
            console.log(e);
        }

        return VersionControlUrls.getFileContentUrl(this.context, this.repositoryId, this.repositoryType, this.projectId, versionControlPath, true);
    }

    private getFileContentUri(path: string): string {

        let repositoryType: VersionControlUrls.RepositoryType = this.repositoryType;
        let versionControlUri: string;

        if (repositoryType === VersionControlUrls.RepositoryType.Git) {

            versionControlUri = this.getGitVersionControlUrl(path);
        }
        else if (repositoryType === VersionControlUrls.RepositoryType.Tfvc) {
            versionControlUri = this.getTfsVersionControlUri(path);
        }
        else {
            return path;
        }

        return versionControlUri;
    }

    public transformImage = (src: string): string => {
        try {
            new Uri(src, { absoluteUriRequired: true });
            return src;
        } catch(e) {}
        let path = new Uri(src); //Performs decoding

        return this.getFileContentUri(path.path);
    }
}
